import React, { useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import fondo from "./ismaael.jpeg";
import "./Buscar.css";
import MenuPrincipal from "./MenuPrincipal";

// 📦 Importar todos los archivos de la carpeta pages
const pages = require.context("./pages", true, /\.jsx$/);
const Buscar = ({ comics = [] }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // 🔍 obtener parámetros desde la URL
  const params = new URLSearchParams(location.search);
  const query = params.get("query")?.toLowerCase() || "";
  const autor = params.get("autor") || ""; // 👈 nuevo parámetro
const tag = params.get("tag") || "";
const idioma = params.get("idioma") || "";
const grupo = params.get("grupo") || "";
const tipo = params.get("tipo") || "";
const serie = params.get("serie") || "";
const personaje = params.get("personaje") || "";
  const [busqueda, setBusqueda] = useState(query);
  const [paginaActual, setPaginaActual] = useState(1);
  const comicsPorPagina = 24; // 6 filas × 4 columnas

  // 🧩 Si se busca por autor, leer directamente los mangas desde /pages
  const obtenerMangasPorAutor = (autor) => {
    const mangas = [];

    pages.keys().forEach((path) => {
      try {
        const modulo = pages(path);
        const info = modulo.infoManga;

        if (
          info?.info?.artistas?.toLowerCase() === autor.toLowerCase()
        ) {
          mangas.push({
            id: info.titulo,
            nombre: info.titulo,
            imagen: info.portada,
enlace:
  info.enlace ||
  `/comic/${info.titulo
    .toLowerCase()
    .replace(/\s+/g, "")
    .replace(/[^a-z0-9]/g, "")}`,
  
  });
        }
      } catch (error) {
        console.error("Error leyendo", path, error);
      }
    });

    return mangas;
  };
  // 🔎 Determinar resultados según el tipo de búsqueda
  let resultados = [];

if (autor) {
  resultados = obtenerMangasPorAutor(autor);

} else if (tag) {

  resultados = [];

  pages.keys().forEach((path) => {
    try {
      const modulo = pages(path);
      const info = modulo.infoManga;

      if (
        info?.info?.etiquetas?.some(
          (t) => t.toLowerCase() === tag.toLowerCase()
        )
      ) {
      resultados.push({
  id: info.titulo,
  nombre: info.titulo,
  imagen: info.portada,
  fecha: info.fecha,

  enlace:
    info.enlace ||
    `/comic/${info.titulo
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^a-z0-9]/g, "")}`,
});
      }

    } catch (error) {
      console.error("Error leyendo", path, error);
    }
  });

} else if (idioma) {

  resultados = [];

  pages.keys().forEach((path) => {
    try {
      const modulo = pages(path);
      const info = modulo.infoManga;

      const idiomas = Array.isArray(info?.info?.idioma)
        ? info.info.idioma.map((i) => i.toLowerCase())
        : [info?.info?.idioma?.toLowerCase()];

      if (idiomas.includes(idioma.toLowerCase())) {
        resultados.push({
  id: info.titulo,
  nombre: info.titulo,
  imagen: info.portada,
  fecha: info.fecha,

  enlace:
    info.enlace ||
    `/comic/${info.titulo
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^a-z0-9]/g, "")}`,
});
      }

    } catch (error) {
      console.error("Error leyendo", path, error);
    }
  });

} else if (grupo) {

  resultados = [];

  pages.keys().forEach((path) => {
    try {
      const modulo = pages(path);
      const info = modulo.infoManga;

      const grupos = Array.isArray(info?.info?.grupo)
        ? info.info.grupo.map((g) => g.toLowerCase())
        : [info?.info?.grupo?.toLowerCase()];

      if (grupos.includes(grupo.toLowerCase())) {
       resultados.push({
  id: info.titulo,
  nombre: info.titulo,
  imagen: info.portada,
  fecha: info.fecha,

  enlace:
    info.enlace ||
    `/comic/${info.titulo
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^a-z0-9]/g, "")}`,
});
      }

    } catch (error) {
      console.error("Error leyendo", path, error);
    }
  });

} else if (tipo) {

  resultados = [];

  pages.keys().forEach((path) => {
    try {
      const modulo = pages(path);
      const info = modulo.infoManga;

      const tipos = Array.isArray(info?.info?.tipo)
        ? info.info.tipo.map((t) => t.toLowerCase())
        : [info?.info?.tipo?.toLowerCase()];

      if (tipos.includes(tipo.toLowerCase())) {
       resultados.push({
  id: info.titulo,
  nombre: info.titulo,
  imagen: info.portada,
  fecha: info.fecha,

  enlace:
    info.enlace ||
    `/comic/${info.titulo
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^a-z0-9]/g, "")}`,
});
      }

    } catch (error) {
      console.error("Error leyendo", path, error);
    }
  });

} else if (serie) {

  resultados = [];

  pages.keys().forEach((path) => {
    try {
      const modulo = pages(path);
      const info = modulo.infoManga;

      const series = Array.isArray(info?.info?.serie)
        ? info.info.serie.map((s) => s.toLowerCase())
        : [info?.info?.serie?.toLowerCase()];

      if (series.includes(serie.toLowerCase())) {
       resultados.push({
  id: info.titulo,
  nombre: info.titulo,
  imagen: info.portada,
  fecha: info.fecha,

  enlace:
    info.enlace ||
    `/comic/${info.titulo
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^a-z0-9]/g, "")}`,
});
      }

    } catch (error) {
      console.error("Error leyendo", path, error);
    }
  });

} else if (personaje) {

  resultados = [];

  pages.keys().forEach((path) => {
    try {
      const modulo = pages(path);
      const info = modulo.infoManga;

      if (
        info?.info?.personajes?.some(
          (p) => p.toLowerCase() === personaje.toLowerCase()
        )
      ) {
       resultados.push({
  id: info.titulo,
  nombre: info.titulo,
  imagen: info.portada,
  fecha: info.fecha,

  enlace:
    info.enlace ||
    `/comic/${info.titulo
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^a-z0-9]/g, "")}`,
});

      }

    } catch (error) {
      console.error("Error leyendo", path, error);
    }
  });

} else {

  resultados = comics.filter((comic) =>
    comic.nombre.toLowerCase().includes(query)
  );

}
resultados = resultados.sort((a, b) => {
  const fechaA = a.fecha ? new Date(a.fecha) : new Date(0);
  const fechaB = b.fecha ? new Date(b.fecha) : new Date(0);

  return fechaB - fechaA;
});
  const totalPaginas = Math.ceil(resultados.length / comicsPorPagina);
  const inicio = (paginaActual - 1) * comicsPorPagina;
  const visibles = resultados.slice(inicio, inicio + comicsPorPagina);

  // Imagen por defecto
  const imagenDefault =
    "https://i.pinimg.com/originals/61/f4/62/61f46295cbd5662b7f79af05e97d6404.jpg";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (busqueda.trim() !== "") {
      navigate(`/buscar?query=${encodeURIComponent(busqueda)}`);
      setPaginaActual(1);
    }
  };

  return (
    <div>
      {/* === CABECERA === */}
      <header
        className="header-fondo"
        style={{
          background: `url(${fondo}) no-repeat center center/cover`,
          padding: "40px 0",
          textAlign: "center",
          color: "#fff",
        }}
      >
        <h1 className="titulo">TMOXNight</h1>

       <MenuPrincipal />

       
      </header>

      {/* === RESULTADOS === */}
      <section className="buscar-body">
        {visibles.length > 0 ? (
          <>
          <h2 className="titulo-autores" style={{ margin: "20px 0" }}>
{autor
  ? `Mangas de ${autor}`
  : tag
  ? `Mangas con la etiqueta "${tag}"`
  : idioma
  ? `Mangas en idioma ${idioma}`
  : grupo
  ? `Mangas del grupo ${grupo}`
  : tipo
  ? `Mangas tipo ${tipo}`
  : serie
  ? `Mangas de la serie ${serie}`
  : personaje
  ? `Mangas del personaje ${personaje}`
  : `Resultados para "${busqueda || query}"`}
</h2>


            <div className="grid-resultados">
              {visibles.map((comic) => (
                <div className="glass-card" key={comic.id}>
                  <img
                    src={comic.imagen || imagenDefault}
                    alt={comic.nombre}
                  />
                  <div className="info">
                    <h3>{comic.nombre}</h3>
                    <Link to={comic.enlace} className="btn-leer">
                      Leer ahora
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <h1 className="sin-resultados">
        {autor
  ? `No se encontraron mangas de ${autor}`
  : tag
  ? `No se encontraron mangas con la etiqueta "${tag}"`
  : idioma
  ? `No se encontraron mangas en idioma ${idioma}`
  : grupo
  ? `No se encontraron mangas del grupo ${grupo}`
  : tipo
  ? `No se encontraron mangas tipo ${tipo}`
  : serie
  ? `No se encontraron mangas de la serie ${serie}`
  : personaje
  ? `No se encontraron mangas del personaje ${personaje}`
  : `No se encontraron resultados para "${query}"`}
          </h1>
        )}

        {/* PAGINACIÓN */}
        {totalPaginas > 1 && (
          <div className="paginacion">
            {Array.from({ length: totalPaginas }).map((_, i) => (
              <button
                key={i}
                className={`page-btn ${
                  i + 1 === paginaActual ? "active" : ""
                }`}
                onClick={() => setPaginaActual(i + 1)}
              >
                {i + 1}
              </button>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Buscar;
